import { getRequestV2, deleteRequestV2 } from '../../methods';

const getConnections = () => getRequestV2('connections');

const disconnectConnection = integration =>
  deleteRequestV2(`connections/${integration}`);

const connections = {
  getConnections,
  disconnectConnection,
};

export default connections;
